/**
 * Hands the /quiz theme to the next step, so someone who has just reflected on
 * five questions does not start the Portrait as if from nothing.
 *
 * Privacy, deliberately narrow: only the theme name and who the quiz was for
 * are kept — never the answers — and only in sessionStorage, so it lives in
 * this tab alone, is never sent to the server, and is gone when the tab closes.
 */
const KEY = 'ss_quiz_theme';

export function saveQuizTheme(theme, audience) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ theme, audience }));
  } catch (e) {
    // Storage blocked (private mode, webview) — the next step simply shows no theme.
  }
}

/** The saved theme when the quiz was taken for `audience` ('single' | 'couple'), else null. */
export function readQuizTheme(audience) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return saved && saved.audience === audience && saved.theme ? saved.theme : null;
  } catch (e) {
    return null;
  }
}
